import { Injectable } from "@angular/core";
import { ActivatedRouteSnapshot, CanActivate, Router, RouterStateSnapshot } from "@angular/router";
import { Observable, of } from 'rxjs';
import { LocalStorageService } from '../index.service';
import { OTPService } from './otp.service';

@Injectable()
export class OtpGuard implements CanActivate {
    constructor(
        private _otpService: OTPService,
        private _router: Router,
        private _storageService: LocalStorageService,
    ) { }

    canActivate(
        route: ActivatedRouteSnapshot,
        state: RouterStateSnapshot,
    ): Observable<boolean> {
        if (this._otpService.isAuthenticated()) {
            return of(true);
        } else {
            this._otpService.requestAuthentication(state.url)
            return of(false);
        }
    }
}
